import * as tslib_1 from "tslib";
import { InterfaceService } from '@app/interfaces';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject, of } from 'rxjs';
import { TranslateService } from "@ngx-translate/core";
import { debounceTime, switchMap, map, tap, catchError } from "rxjs/operators";
import * as moment from "moment";
import { DatePipe } from "@app/pipes";
import { TimelineDatePipe } from "@app/pipes/timeline-date.pipe";
import { SettingsService } from "@app/core";
import { TimelineService } from "@app/shared/services/timeline.service";
import { CommonService } from "@app/services";
var ScheduledActivityService = /** @class */ (function (_super) {
    tslib_1.__extends(ScheduledActivityService, _super);
    function ScheduledActivityService(http, translate, ShortDatePipe, TimelineDatePipe, settingsService, timelineService, commonService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.translate = translate;
        _this.ShortDatePipe = ShortDatePipe;
        _this.TimelineDatePipe = TimelineDatePipe;
        _this.settingsService = settingsService;
        _this.timelineService = timelineService;
        _this.commonService = commonService;
        _this.viewOpportunityAccess = false;
        _this.freemiumAccess = false;
        _this.filterActionEnabled = true;
        _this.RunThroughScheduledActivitiesAccess = false;
        _this.isOldJobView = false;
        _this.lastCommRequest$ = new Subject();
        _this.filterData = new BehaviorSubject('');
        _this.filterData$ = _this.filterData.asObservable();
        _this.filterParams = new BehaviorSubject('');
        _this.filterParams$ = _this.filterParams.asObservable();
        _this.refreshActivityList = new BehaviorSubject(null);
        _this.$refreshActivityList = _this.refreshActivityList.asObservable();
        _this.getActivityList = function (data) {
            var url = _this.getApiUrl('getScheduledActivitiesData');
            var params = {
                date: data.date,
                searchText: data.searchText,
                limit: data.limit,
                page: data.page,
                order: data.order,
                field: data.field,
                type: Array.isArray(data.type) ? data.type.join(',') : data.type,
                recordType: data.recordType,
                filters: JSON.stringify(data.filters),
                selectedTab: data.activeTab,
            };
            return _this.http.get(url, { params: params }).pipe(map(function (response) { return ({
                data: response.scheduledActivities,
                count: response.count,
                params: params,
            }); }));
        };
        _this.lastCommRequest$
            .pipe(debounceTime(ScheduledActivityService.LAST_COMM_DEBOUNCE_MS), switchMap(function (params) {
            return _this.http.get(_this.getApiUrl("lastCommunication?tableType=" + params.tableType + "&tablePKID=" + params.tablePKID + "&type=" + params.recordType + "&diaryId=" + params.diaryId)).pipe(map(function (res) {
                var lastCommunication = null;
                var lastVisit = null;
                if (res != null) {
                    if (res.lastCommunication !== undefined) {
                        lastCommunication = res.lastCommunication;
                    }
                    else if (res.lastCommuncation !== undefined) {
                        lastCommunication = res.lastCommuncation;
                    }
                    if (res.lastVisit !== undefined) {
                        lastVisit = res.lastVisit;
                    }
                }
                return {
                    lastCommunication: lastCommunication,
                    lastVisit: lastVisit,
                    lastCommunicationContainerId: params.lastCommunicationContainerId,
                    lastVisitContainerId: params.lastVisitContainerId
                };
            }), catchError(function () { return of({
                lastCommunication: null,
                lastVisit: null,
                lastCommunicationContainerId: params.lastCommunicationContainerId,
                lastVisitContainerId: params.lastVisitContainerId
            }); }));
        }))
            .subscribe({
            next: function (_a) {
                var lastCommunication = _a.lastCommunication, lastVisit = _a.lastVisit, lastCommunicationContainerId = _a.lastCommunicationContainerId, lastVisitContainerId = _a.lastVisitContainerId;
                var container = document.getElementById(lastCommunicationContainerId);
                var lastVisitContainer = document.getElementById(lastVisitContainerId);
                if (container) {
                    container.innerHTML = _this.buildLastCommunicationHTML(lastCommunication);
                }
                if (lastVisitContainer) {
                    lastVisitContainer.innerHTML = _this.buildLastVisitHTML(lastVisit);
                }
            },
            error: function () { }
        });
        _this.commonService.$currentUser.subscribe(function (data) {
            _this.currentUser = data;
        });
        return _this;
    }
    ScheduledActivityService.prototype.setFilterData = function (data) {
        this.filterData.next(data);
    };
    ScheduledActivityService.prototype.setFilterParams = function (data) {
        this.filterParams.next(data);
    };
    ScheduledActivityService.prototype.setRefreshActivityList = function (data) {
        this.refreshActivityList.next(data);
    };
    ScheduledActivityService.prototype.getScheduledActivityData = function () {
        var url = this.getApiUrl("sales/getScheduledActivities");
        return this.http.get(url);
    };
    ScheduledActivityService.prototype.getScheduledEmail = function (oppid) {
        var url = this.getApiUrl("sales/checkTodayEmailActivity/" + oppid);
        return this.http.get(url);
    };
    ScheduledActivityService.prototype.getScheduledActivityList = function (data) {
        var url = this.getApiUrl(data['url'], data['params']);
        return this.http.get(url);
    };
    ScheduledActivityService.prototype.getScheduledActivities = function () {
        var url = this.getApiUrl('getScheduledActivitiesData');
        return this.http.get(url);
    };
    ScheduledActivityService.prototype.getFilterDatas = function (data) {
        var url = this.getApiUrl("getScheduledActivitiesData?assignee=" + data.assignee + "&date=" + data.date + "&searchText=" + data.searchText + "&limit=" + data.pageLimit + "&page=" + data.currentPage + "&order=" + data.order + "&field=" + data.field + "&type=" + data.type + "&recordType=" + data.recordType);
        return this.http.get(url);
    };
    ScheduledActivityService.prototype.completeScheduledActivity = function (data) {
        var url = this.getApiUrl("completeScheduledActivity");
        return this.http.post(url, data);
    };
    ScheduledActivityService.prototype.setGridInstance = function (instance) {
        this.gridInstance = instance;
    };
    ScheduledActivityService.prototype.setViewOpportunityAccess = function (freemium, opportunity, RunThroughScheduledActivities) {
        this.viewOpportunityAccess = opportunity;
        this.freemiumAccess = freemium;
        this.RunThroughScheduledActivitiesAccess = RunThroughScheduledActivities;
    };
    ScheduledActivityService.prototype.getGridConfig = function (activeTab, openDeleteModal, openViewModal, openEditModal, runThrough, permissions, usersList, appliedData, completeSelected, onContactClick, onDataLoad) {
        var _this = this;
        this.usersList = usersList;
        var colDefs;
        var filterDefs;
        switch (activeTab) {
            case 'myActivity':
            case 'othersActivity':
            case 'ai-den':
            case 'unassignedActivity':
            case 'complete':
                colDefs = this.getMyActivityGridColumn(activeTab, openDeleteModal, openViewModal, openEditModal, permissions, onContactClick);
                filterDefs = this.getMyActivityGridFilter(activeTab, runThrough, permissions, appliedData);
                break;
        }
        var gridConfig = {
            hideHeaderPanel: true,
            filterPanelConfig: filterDefs,
            gridConfig: {
                enableDetailGrid: false,
                rowsPerPage: 10,
                rowHeight: 80,
                rowSelection: activeTab != 'ai-den',
                hideHeaderRowSelection: true,
                colDefs: colDefs,
                dataResKeys: { dataKey: 'data', countKey: 'count' },
                onRowSelection: function (event, data) { return completeSelected(event, data); },
                gridList: function (params) {
                    var reqParams = params['reqParams'] || {};
                    reqParams['filters'] = reqParams['filters'] ? JSON.parse(reqParams['filters']) : null;
                    if (reqParams['filters']) {
                        var isJobRecordType = reqParams['filters'].some(function (f) { return f.ID == 'recordType' && f.value == 'job'; });
                        if (isJobRecordType && 'clientsconfig' in _this.settingsService.getAllPermissions()['accessDetails'] && 'NewJobView' in _this.settingsService.getAllPermissions()['accessDetails'].clientsconfig && _this.settingsService.getAllPermissions()['accessDetails'].clientsconfig.NewJobView == false) {
                            _this.isOldJobView = true;
                        }
                        else {
                            _this.isOldJobView = false;
                        }
                    }
                    return _this.getActivityList(tslib_1.__assign({}, appliedData, reqParams, { activeTab: activeTab })).pipe(tap(function (res) {
                        // Notify the component whenever data arrives
                        _this.filterActionEnabled = !!(res.data.length);
                        if (onDataLoad)
                            onDataLoad(res);
                    }));
                }
            }
        };
        return gridConfig;
    };
    ScheduledActivityService.prototype.getMyActivityGridColumn = function (activeTab, openDeleteModal, openViewModal, openEditModal, permissions, onContactClick) {
        var _this = this;
        return [
            {
                field: 'activityType',
                headerName: '',
                maxWidth: 50,
                resizable: true,
                cellRenderer: function (params) {
                    var data = params.data || {};
                    var content = data.activityType;
                    if (!content) {
                        return "<span>-</span>";
                    }
                    else if (content == 'Call') {
                        return "<span style=\"display: flex; justify-content: center;\"><i class=\"fa-solid fa-phone\"></i></span>";
                    }
                    else if (content == 'Email') {
                        return "<span style=\"display: flex; justify-content: center;\"><i class=\"fa fa-envelope\"></i></span>";
                    }
                    else if (content == 'Meeting') {
                        return "<span style=\"display: flex; justify-content: center;\"><i class=\"fa-solid fa-handshake\"></i></span>";
                    }
                    else if (content == 'Task') {
                        return "<span style=\"display: flex; justify-content: center;\"><i class=\"fa-solid fa-briefcase\"></i></span>";
                    }
                    else if (content == 'Service reminder') {
                        return "<span style=\"display: flex; justify-content: center;\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\">\n                        <g clip-path=\"url(#clip0_9399_20295)\">\n                            <path d=\"M7.33084 3.22231C7.10527 2.67741 6.51057 2.38738 5.94223 2.54265L3.36422 3.24575C2.85448 3.38636 2.5 3.84923 2.5 4.37655C2.5 11.6243 8.37669 17.501 15.6244 17.501C16.1517 17.501 16.6146 17.1465 16.7552 16.6368L17.4583 14.0587C17.6136 13.4904 17.3236 12.8957 16.7787 12.6701L13.9663 11.4983C13.4888 11.2991 12.9351 11.4368 12.6099 11.8381L11.4264 13.2824C9.36396 12.3069 7.69411 10.637 6.71856 8.57461L8.16284 7.394C8.56419 7.06589 8.70188 6.51513 8.50267 6.03761L7.33084 3.22524V3.22231Z\" fill=\"url(#paint0_linear_9399_20295)\"/>\n                            <path d=\"M13.7944 2.27065C14.0436 1.54148 15.0511 1.5194 15.3465 2.2044L15.3715 2.27107L15.7077 3.2544C15.7848 3.47992 15.9093 3.68628 16.0729 3.85958C16.2365 4.03288 16.4353 4.16907 16.6561 4.25899L16.7465 4.29274L17.7298 4.62857C18.459 4.87774 18.4811 5.88524 17.7965 6.18065L17.7298 6.20565L16.7465 6.5419C16.5209 6.61891 16.3144 6.74341 16.1411 6.90701C15.9677 7.07061 15.8314 7.26949 15.7415 7.49024L15.7077 7.58024L15.3719 8.56399C15.1227 9.29315 14.1152 9.31524 13.8202 8.63065L13.7944 8.56399L13.4585 7.58065C13.3815 7.35506 13.257 7.14861 13.0934 6.97524C12.9298 6.80187 12.731 6.66561 12.5102 6.57565L12.4202 6.5419L11.4369 6.20607C10.7073 5.9569 10.6852 4.9494 11.3702 4.6544L11.4369 4.62857L12.4202 4.29274C12.6457 4.21568 12.8521 4.09115 13.0254 3.92756C13.1987 3.76396 13.3349 3.56511 13.4248 3.3444L13.4585 3.2544L13.7944 2.27065ZM17.9165 0.833984C17.9944 0.833984 18.0708 0.85585 18.1369 0.897098C18.2031 0.938345 18.2563 0.997319 18.2906 1.06732L18.3106 1.11607L18.4565 1.54357L18.8844 1.6894C18.9625 1.71594 19.031 1.76507 19.0811 1.83057C19.1313 1.89607 19.1609 1.97499 19.1662 2.05733C19.1714 2.13966 19.1521 2.22171 19.1107 2.29306C19.0693 2.36442 19.0077 2.42188 18.9336 2.45815L18.8844 2.47815L18.4569 2.62398L18.3111 3.0519C18.2845 3.13 18.2353 3.19844 18.1698 3.24857C18.1042 3.29869 18.0253 3.32823 17.943 3.33345C17.8607 3.33867 17.7786 3.31934 17.7073 3.27789C17.636 3.23645 17.5785 3.17476 17.5423 3.10065L17.5223 3.0519L17.3765 2.6244L16.9486 2.47857C16.8704 2.45203 16.802 2.4029 16.7518 2.3374C16.7016 2.2719 16.672 2.19298 16.6668 2.11064C16.6615 2.02831 16.6808 1.94626 16.7222 1.87491C16.7636 1.80355 16.8253 1.74609 16.8994 1.70982L16.9486 1.68982L17.3761 1.54398L17.5219 1.11607C17.55 1.03375 17.6031 0.96228 17.6739 0.911692C17.7447 0.861105 17.8295 0.833932 17.9165 0.833984Z\" fill=\"url(#paint1_linear_9399_20295)\"/>\n                        </g>\n                        <defs>\n                            <linearGradient id=\"paint0_linear_9399_20295\" x1=\"2.5\" y1=\"12.251\" x2=\"17.4994\" y2=\"12.1568\" gradientUnits=\"userSpaceOnUse\">\n                                <stop stop-color=\"#80216E\"/>\n                                <stop offset=\"1\" stop-color=\"#D67C39\"/>\n                            </linearGradient>\n                            <linearGradient id=\"paint1_linear_9399_20295\" x1=\"10.8726\" y1=\"6.22509\" x2=\"19.1667\" y2=\"6.17304\" gradientUnits=\"userSpaceOnUse\">\n                                <stop stop-color=\"#80216E\"/>\n                                <stop offset=\"1\" stop-color=\"#D67C39\"/>\n                            </linearGradient>\n                            <clipPath id=\"clip0_9399_20295\">\n                                <rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0 0.000976562)\"/>\n                            </clipPath>\n                        </defs>\n                    </svg></span>";
                    }
                }
            },
            {
                field: 'customerDetails',
                headerName: this.translate.instant('Description'),
                minWidth: 260,
                resizable: true,
                cellRenderer: function (params) {
                    var data = params.data || {};
                    var content = data.description;
                    var tags = data.savedTags || [];
                    if (!content) {
                        return "<span>-</span>";
                    }
                    else {
                        // Build HTML for tags
                        var tagsHtml = '';
                        if (tags.length > 0) {
                            tagsHtml = tags.map(function (tag) { return "<span style=\"padding:4px 5px 2px; margin-right:8px; border-radius:2px; font-size:12px;border: 1px solid var(--Base-structure-Stroke, #E1E1E1);background: var(--Background-Light-BG, #FAFAFA);\">" + tag.description + "</span>"; }).join('');
                        }
                        return "<div style=\"overflow: hidden; text-overflow: ellipsis;\"><span " + _this.truncateStyle(content) + ">" + content + "</span><span *ngIf=\"" + tags.length + "\" style=\"height: 6px;display: flex\"></span>" + tagsHtml + "</div>";
                    }
                }
            },
            {
                field: 'timeToShow',
                headerName: this.translate.instant('Due date/time'),
                minWidth: 250,
                resizable: true,
                cellRenderer: function (params) {
                    var data = params.data || {};
                    var content = data.timeToShow;
                    if (!content) {
                        return "<span>-</span>";
                    }
                    else {
                        var DateVlaue = _this.ModifyActivityDateTime(content);
                        return "<span>" + DateVlaue + "</span>";
                    }
                }
            },
            {
                field: 'Status',
                headerName: this.translate.instant('Status'),
                minWidth: 140,
                resizable: true,
                cellRenderer: function (params) {
                    var data = params.data || {};
                    var content = data.dateToShow;
                    if (!content) {
                        return "<span>-</span>";
                    }
                    else {
                        var DateValue = _this.ModifyActivityDate(content).label;
                        var bgColor = DateValue === 'Overdue' ? '#BE6D6D' : '#477596';
                        var icon = DateValue === 'Overdue' ? '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                            '<path d="M7.05108 1.33219C7.36508 1.12419 7.89708 0.975686 8.29858 1.37719L10.6221 3.70119C11.0251 4.10319 10.8761 4.63519 10.6676 4.94869C10.5547 5.11868 10.4078 5.26339 10.2361 5.37369C10.0691 5.48019 9.85808 5.56069 9.63058 5.54869C9.52051 5.54089 9.41077 5.52905 9.30158 5.51319L9.26758 5.50819C9.15027 5.49137 9.03234 5.47919 8.91408 5.47169C8.66208 5.45919 8.56508 5.50169 8.53408 5.53169L7.28908 6.77719C7.24908 6.81719 7.19908 6.90619 7.16108 7.07719C7.12458 7.24219 7.10858 7.44519 7.10458 7.67019C7.10108 7.88619 7.10858 8.10719 7.11658 8.32019L7.11708 8.34369C7.12458 8.55519 7.13208 8.77119 7.12158 8.94069C7.08908 9.45619 6.68758 9.83569 6.29258 10.0112C5.89758 10.1862 5.33408 10.2297 4.94258 9.83769L3.81758 8.71269L1.76508 10.7652C1.73075 10.802 1.68935 10.8316 1.64335 10.8521C1.59735 10.8726 1.54769 10.8836 1.49734 10.8845C1.44699 10.8854 1.39697 10.8761 1.35028 10.8572C1.30358 10.8384 1.26117 10.8103 1.22556 10.7747C1.18995 10.7391 1.16188 10.6967 1.14302 10.65C1.12415 10.6033 1.11489 10.5533 1.11578 10.5029C1.11667 10.4526 1.12769 10.4029 1.14819 10.3569C1.16868 10.3109 1.19823 10.2695 1.23508 10.2352L3.28708 8.18269L2.16208 7.05769C1.77058 6.66569 1.81358 6.10269 1.98908 5.70769C2.16408 5.31269 2.54408 4.91119 3.05908 4.87869C3.22908 4.86819 3.44508 4.87569 3.65658 4.88319L3.68008 4.88369C3.89308 4.89119 4.11408 4.89919 4.33008 4.89569C4.55508 4.89169 4.75808 4.87569 4.92308 4.83919C5.09408 4.80119 5.18308 4.75069 5.22308 4.71069L6.46808 3.46569C6.49858 3.43519 6.54108 3.33769 6.52808 3.08569C6.52057 2.96742 6.50839 2.84949 6.49158 2.73219L6.48708 2.69819C6.47121 2.58899 6.45937 2.47925 6.45158 2.36919C6.43908 2.14169 6.51958 1.93069 6.62558 1.76369C6.73358 1.59369 6.88308 1.44369 7.05108 1.33219Z" fill="white"/>\n' +
                            '</svg>\n' : '';
                        var safeTitle = _this.escapeTitle(DateValue);
                        var escaped = _this.escapeTitle(DateValue);
                        return "<div style=\"min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;\" title=\"" + safeTitle + "\"><span style=\"background-color: " + bgColor + "; color: white; padding: 2px 6px; border-radius: 2px; display:inline-flex; align-items:center; gap:4px; min-width:0; max-width:100%; overflow:hidden;\"><span style=\"flex-shrink:0\">" + icon + "</span><span style=\"overflow:hidden; text-overflow:ellipsis; white-space:nowrap; min-width:0;\">" + escaped + "</span></span></div>";
                    }
                }
            },
            {
                field: 'customer name',
                headerName: this.translate.instant('Customer name'),
                minWidth: 150,
                resizable: true,
                cellRenderer: function (params) {
                    var data = params.data || {};
                    var content = data.customerDetails.customerName;
                    if (!content) {
                        return "<span>-</span>";
                    }
                    else {
                        return "<span " + _this.truncateStyle(content) + ">" + content + "</span>";
                    }
                }
            },
            {
                field: 'Phone',
                headerName: this.translate.instant('Project.Customer.Contact'),
                minWidth: 220,
                resizable: true,
                cellRenderer: function (params) {
                    var data = params.data || {};
                    var customer = data.customerDetails || {};
                    var mobile = customer.customerMobileNumber;
                    var telephone = customer.customerTelephoneNumber;
                    var email = customer.customerEmail;
                    if (!mobile && !telephone && !email) {
                        return "<span>-</span>";
                    }
                    // Build the HTML – fixed-width icon wrapper so phone/mobile/email align
                    var html = '';
                    var iconWrap = 'style="display: inline-block; width: 20px; text-align: center; vertical-align: middle;"';
                    var truncateContact = function (val) { return "style=\"display: inline-block; max-width: 190px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #3883c1; cursor: pointer; vertical-align: middle;\" title=\"" + _this.escapeTitle(val) + "\""; };
                    if (telephone) {
                        html += "<span class=\"clickable-phone\" data-type=\"telephone\" style=\"display: flex; align-items: center; gap: 4px;\"><span " + iconWrap + "><i class=\"fa-solid fa-phone\"></i></span><span " + truncateContact(telephone) + ">" + telephone + "</span></span>";
                    }
                    if (mobile) {
                        html += "<span class=\"clickable-phone\" data-type=\"mobile\" style=\"display: flex; align-items: center; gap: 4px;\"><span " + iconWrap + "><i class=\"fa-solid fa-mobile-screen-button\"></i></span><span " + truncateContact(mobile) + ">" + mobile + "</span></span>";
                    }
                    if (email) {
                        html += "<span class=\"clickable-phone\" data-type=\"email\" style=\"display: flex; align-items: center; gap: 4px;\"><span " + iconWrap + "><i class=\"fa-solid fa-envelope\"></i></span><span " + truncateContact(email) + ">" + email + "</span></span>";
                    }
                    // Create a wrapper element to attach events
                    var wrapper = document.createElement('div');
                    wrapper.innerHTML = html;
                    // Attach click events
                    wrapper.querySelectorAll('.clickable-phone').forEach(function (el) {
                        el.addEventListener('click', function () {
                            var type = el.getAttribute('data-type');
                            onContactClick(data, type);
                        });
                    });
                    return wrapper;
                }
            },
            {
                field: 'Object',
                headerName: this.translate.instant('Object'),
                minWidth: 150,
                resizable: true,
                cellRenderer: 'customPopOverRenderer',
                cellRendererParams: {
                    popUpDetail: function (data) { return _this.buildPopupHTML(data); },
                    activity: true
                }
            },
            {
                field: 'site name/address',
                headerName: this.translate.instant('Site name/address'),
                minWidth: 150,
                resizable: true,
                cellRenderer: function (params) {
                    var data = params.data || {};
                    var content = data.siteContactDetails.siteContactAddress;
                    if (!content) {
                        return "<span>-</span>";
                    }
                    else {
                        return "<span " + _this.truncateStyle(content) + ">" + content + "</span>";
                    }
                }
            },
            {
                field: 'assignees',
                headerName: this.translate.instant('Assigned'),
                minWidth: 170,
                resizable: true,
                cellRenderer: 'customUserRenderer'
            },
            {
                field: 'action',
                headerName: this.translate.instant('Action'),
                minWidth: 150,
                cellRenderer: 'actionRenderer',
                pinned: 'right',
                hide: activeTab == 'ai-den',
                cellRendererParams: {
                    actions: [
                        {
                            id: 'view',
                            text: 'View',
                            onClick: function (data) { return openViewModal(data); },
                            hide: function (data) {
                                if (data.recordType === 'Opportunity') {
                                    return !(_this.viewOpportunityAccess && (!data.jmsOnly || _this.freemiumAccess));
                                }
                                else if (data.recordType === 'customer' || data.recordType === 'contract' || data.recordType === 'job') {
                                    return false;
                                }
                                return true;
                            },
                        },
                        {
                            id: 'edit_requested',
                            text: 'Edit',
                            onClick: function (data) { return openEditModal(data); },
                            hide: function () { return !permissions.update; },
                        },
                        {
                            id: 'Delete',
                            text: 'Delete',
                            onClick: function (data) { return openDeleteModal(data); },
                            hide: function () { return !permissions.delete; },
                        }
                    ]
                }
            }
        ];
    };
    ScheduledActivityService.prototype.valOrDash = function (val) {
        return val !== undefined && val !== null && val !== '' ? val : '-';
    };
    /** Escape string for use in HTML title attribute (tooltip). */
    ScheduledActivityService.prototype.escapeTitle = function (val) {
        if (val == null)
            return '';
        return String(val)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    };
    /** Inline style for truncating text with ellipsis + optional title for full text tooltip. */
    ScheduledActivityService.prototype.truncateStyle = function (title) {
        var base = 'display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;';
        if (title) {
            return "style=\"" + base + "\" title=\"" + this.escapeTitle(title) + "\"";
        }
        return "style=\"" + base + "\"";
    };
    ScheduledActivityService.prototype.normalizeVisitDate = function (dateValue) {
        if (!dateValue) {
            return null;
        }
        if (typeof dateValue === 'string') {
            return dateValue.replace(/\.\d+$/, '');
        }
        if (typeof dateValue === 'object' && dateValue.date) {
            return String(dateValue.date).replace(/\.\d+$/, '');
        }
        return null;
    };
    ScheduledActivityService.prototype.buildLastCommunicationHTML = function (lastCommunication) {
        if (!lastCommunication) {
            return "\n    <div class=\"flex-display pt-5\">\n            There are no communications\n    </div>\n    ";
        }
        if (lastCommunication.emailId) {
            var fromName = '';
            if (lastCommunication.createdBy) {
                fromName = lastCommunication.isUserDeleted
                    ? lastCommunication.companyName
                    : lastCommunication.createdBy;
            }
            else {
                fromName = lastCommunication.mailFromName;
            }
            return "\n    <div class=\"flex-display pt-5\">\n        <div class=\"w-8\"><i class=\"fa fa-envelope last-com-icon\"></i></div>\n        <div class=\"w-92 last-communication\">\n            <span>" + this.valOrDash(this.timelineService.convertTimeLineDateTime(lastCommunication.dateToShow)) + "</span>\n            <div class=\"pt-3\"><b>From:</b> " + this.valOrDash(fromName) + "</div>\n            <div class=\"pt-3\"><b>To:</b> " + this.valOrDash(lastCommunication.mailToName) + "</div>\n            <div class=\"pt-3 message\"><b class=\"mr-4\">Subject:</b>" + this.valOrDash(lastCommunication.subject) + "</div>\n        </div>\n    </div>\n    ";
        }
        if (lastCommunication.smsId) {
            return "\n    <div class=\"flex-display pt-5\">\n        <div class=\"w-8\"><i class=\"fas fa-sms last-com-icon\"></i></div>\n        <div class=\"w-92 last-communication\">\n            <span>" + this.valOrDash(this.timelineService.convertTimeLineDateTime(lastCommunication.dateToShow)) + "</span>\n            <div class=\"pt-3\"><b>To:</b> " + this.valOrDash(lastCommunication.smsContactName) + "</div>\n            <div class=\"pt-3 message\"><b class=\"mr-4\">Message:</b>" + this.valOrDash(lastCommunication.message) + "</div>\n        </div>\n    </div>\n    ";
        }
        if (lastCommunication.phoneId) {
            return "\n    <div class=\"flex-display pt-5\">\n    <div class=\"w-8\"><i class=\"fa fa-phone last-com-icon\"></i></div>\n        <div class=\"w-92 last-communication\">\n            <span>" + this.valOrDash(this.timelineService.convertTimeLineDateTime(lastCommunication.dateToShow)) + "</span>\n            <div class=\"pt-3\"><b>To:</b> " + this.valOrDash(lastCommunication.contactName) + "</div>\n            <div class=\"pt-3 message\"><b class=\"mr-4\">Message:</b>" + this.valOrDash(lastCommunication.phoneCallNote) + "</div>\n        </div>\n    </div>\n    ";
        }
        if (lastCommunication.printId) {
            return "\n    <div class=\"flex-display pt-5\">\n    <div class=\"w-8\"><i class=\"fa fa-print last-com-icon\"></i></div>\n        <div class=\"w-92 last-communication\">\n            <span>" + this.valOrDash(this.timelineService.convertTimeLineDateTime(lastCommunication.dateToShow)) + "</span>\n            <div class=\"pt-3\">" + this.valOrDash(lastCommunication.printMessage) + "</div>\n        </div>\n    </div>\n    ";
        }
        return "\n    <div class=\"flex-display pt-5\">\n            There are no communications\n    </div>\n    ";
    };
    ScheduledActivityService.prototype.buildLastCommunicationLoadingHTML = function () {
        return "\n                <div class=\"flex-display pt-5\">\n                    <div class=\"w-8\">\n                        <div class=\"animated-background\" style=\"width: 16px; height: 12px;\"></div>\n                    </div>\n                    <div class=\"w-92 last-communication\">\n                        <div class=\"text-layout animated-background\" style=\"width: 200px; height: 12px;\"></div>\n                        <div class=\"text-layout animated-background\" style=\"width: 200px; height: 12px; margin-top: 8px;\"></div>\n                        <div class=\"text-layout animated-background\" style=\"width: 200px; height: 12px; margin-top: 8px;\"></div>\n                    </div>\n                </div>\n    ";
    };
    ScheduledActivityService.prototype.buildLastVisitHTML = function (lastVisitData) {
        var visit = Array.isArray(lastVisitData) ? lastVisitData[0] : lastVisitData;
        if (!visit) {
            return "<div>There are no diary events in the past</div>";
        }
        var description = visit.Description !== undefined ? visit.Description : visit.description;
        var profilePicture = visit.profilePicture !== undefined ? visit.profilePicture : visit.ProfilePicture;
        var engineerName = visit.engineerName !== undefined ? visit.engineerName : visit.EngineerName;
        var fromDateValue = visit.job_id
            ? (visit.lastVisitedDate !== undefined ? visit.lastVisitedDate : visit.FromDateTime)
            : visit.fromDate;
        var fromDate = this.normalizeVisitDate(fromDateValue);
        var formattedDateValue = fromDate ? this.timelineService.convertTimeLineDateTime(fromDate, 'date') : '';
        var formattedDate = formattedDateValue === 'Invalid date' ? '' : formattedDateValue;
        var time = visit.time !== undefined ? visit.time : '';
        return "\n                <div class=\"flex-display pt-5\">\n                    <div class=\"w-8\">\n                        <i class=\"fa fa-calendar-alt last-com-icon\"></i>\n                    </div>\n                    <div class=\"w-92 last-communication\">\n                        <span>" + this.valOrDash(description) + "</span>\n\n                        <div class=\"last-visit-row\">\n                                 " + (profilePicture ? "\n                                    <img class=\"profile-picture\" src=\"" + profilePicture + "\">\n                                " : "\n                                    <img src=\"images/profile_avatar_small.jpg\" alt=\"Avatar\" class=\"profile-picture\">\n                                ") + "\n                                 <span class=\"text\">" + this.valOrDash(engineerName) + "</span>\n                        </div>\n\n                        <div class=\"last-visit-row\">\n                            <i class=\"fa fa-calendar-alt last-com-icon\"></i>\n                            <span class=\"text\">\n                                " + this.valOrDash(formattedDate) + "\n                                " + (time ? "(" + time + ")" : '') + "\n                             </span>\n                        </div>\n                    </div>\n                </div>\n            ";
    };
    ScheduledActivityService.prototype.buildPopupHTML = function (data) {
        var content = (data.recordType || '').toLowerCase();
        var lastCommunicationContainerId = "sched-last-comm-" + Date.now() + "-" + Math.floor(Math.random() * 100000);
        var lastVisitContainerId = "sched-last-visit-" + Date.now() + "-" + Math.floor(Math.random() * 100000);
        var html = "\n      <div class=\"popup-wrapper-sched\">\n        <div class=\"arrow-left-sched\"></div>\n        <div class=\"popup-header-sched\">\n          " + (content === 'job' ? 'Job information' : 'Opportunity information') + "\n        </div>\n        <div class=\"popup-content-sched\">\n    ";
        if (content === 'job') {
            var color = data.stageName ? '#fff' : 'black';
            html += "\n        <div class=\"row-sched\"><strong>Description</strong> <br>" + this.valOrDash(data.recordDescription) + "</div>\n        <div class=\"row-sched\"><strong>Notes</strong> <br>" + this.valOrDash(data.jobNotes) + "</div>\n        <div class=\"row-sched\"><strong>Status</strong>\n        <div class=\"mt-4\">\n          <span class=\"status-badge-sched\" style=\"background: " + data.stageColor + "; color: " + color + "\">" + this.valOrDash(data.stageName) + "</span>\n      ";
            if (data.jobAssignedUsers && data.jobAssignedUsers.length > 0) {
                html += "<span class=\"fl-right\">";
                data.jobAssignedUsers.forEach(function (user, index) {
                    if (index < 3) {
                        html += "\n                        <img src=\"" + (user.profilepicture || 'images/profile_avatar_small.jpg') + "\" alt=\"Avatar\" class=\"avatar-image\">\n                        ";
                    }
                });
                if (data.jobAssignedUsers && data.jobAssignedUsers.length > 3) {
                    html += "<span class=\"user-count\">+" + (data.jobAssignedUsers.length - 3) + "</span>";
                }
                html += '</span>';
            }
            html += "</div></div>";
        }
        if (content === 'opportunity') {
            var lastComm = data.lastCommunication || {};
            var customer = data.customerDetails || {};
            var color = data.opportunityStatus ? '#fff' : 'black';
            html += "\n        <div class=\"row-sched\"><strong>Description</strong> <br> " + this.valOrDash(data.opportunityDescription) + "</div>\n        <div class=\"row-sched\"><strong>Notes</strong> <br> " + this.valOrDash(data.opportunityNotes) + "</div>\n        <div class=\"row-sched\" *ngIf=\"" + this.freemiumAccess + "\"><strong>Sales person</strong> <br>\n        " + (data.salesPerson.salesPersonProfile && data.salesPerson.salesPersonProfile !== '' ? "<img src=\"" + data.salesPerson.salesPersonProfile + "\" class=\"sales-person\">" : "<img src=\"images/profile_avatar_small.jpg\" class=\"sales-person\">") + "\n        <span>" + this.valOrDash(data.salesPerson.salesPersonName) + "</span></div>\n        <div class=\"row-sched\"><strong>Status</strong> </br> <div class=\"popover-sub-content mt-4\"><span class=\"status-text-style status-badge-sched label\n      " + (data.opportunityStatus === 'Rejected' ? 'label-important' : '') + " " + (data.opportunityStatus === 'Accepted' || data.opportunityStatus === 'Ongoing' ? 'label-success' : '') + "\"\n      style=\"color: " + color + "\">\n      " + this.valOrDash(data.opportunityStatus) + "</span></div></div>";
        }
        var tableType = data.recordTableType;
        var tablePKID = data.recordId;
        var recordType = data.recordType;
        var diaryId = data.diaryId;
        this.lastCommRequest$.next({
            tableType: tableType,
            tablePKID: tablePKID,
            recordType: recordType,
            diaryId: diaryId,
            lastCommunicationContainerId: lastCommunicationContainerId,
            lastVisitContainerId: lastVisitContainerId
        });
        html += "\n    <div class=\"border-top\"></div>\n    <div class=\"section-sched\">\n    <div class=\"popover-sub-title\">\n        Last communication\n    </div>\n    <div class=\"popover-sub-content\" id=\"" + lastCommunicationContainerId + "\">\n";
        html += this.buildLastCommunicationLoadingHTML();
        html += "\n    </div>\n</div>\n";
        html += "\n        <div class=\"section-sched\">\n    <div class=\"popover-sub-title\">\n      Last visit\n    </div>\n        <div class=\"popover-sub-content\" id=\"" + lastVisitContainerId + "\">\n            " + this.buildLastCommunicationLoadingHTML() + "\n    </div>\n  </div>\n      ";
        html += "</div></div>";
        return html;
    };
    ScheduledActivityService.prototype.getMyActivityGridFilter = function (activeTab, runThrough, permissions, appliedData) {
        var _this = this;
        var filters = [];
        var actions = [];
        var appliedFilter = [];
        appliedFilter = Array.isArray(appliedData.filters) ? appliedData.filters : [];
        switch (activeTab) {
            case 'myActivity':
            case 'unassignedActivity':
            case 'ai-den':
                filters = [
                    {
                        filterInterfaceLabel: 'Activity type',
                        ID: 'activityType',
                        filterType: 'staticMultiSelect',
                        filterOptions: [
                            { id: '1', text: 'Call' },
                            { id: '2', text: 'Email' },
                            { id: '3', text: 'Meeting' },
                            { id: '4', text: 'Task' },
                        ],
                    },
                    {
                        filterInterfaceLabel: 'Record type',
                        ID: 'recordType',
                        filterType: 'staticSingleSelect',
                        filterOptions: [
                            { id: 'all', text: "All" },
                            { id: 'customer', text: "Customer" },
                            { id: 'opportunity', text: "Opportunity" },
                            { id: 'contract', text: 'Contract' },
                            { id: 'job', text: 'Job' }
                        ],
                    },
                    {
                        filterInterfaceLabel: 'Due dates',
                        ID: 'dueDate',
                        filterType: 'staticSingleSelect',
                        filterOptions: [
                            { id: 'All dates', text: "All dates" },
                            { id: 'Today', text: "Due today" },
                            { id: 'Overdue', text: "Overdue" },
                            { id: 'Tomorrow', text: "Due tomorrow" },
                            { id: 'Week', text: "Due this week" },
                            { id: 'Next_week', text: "Due next week" },
                        ],
                    }
                ];
                // Add action only for these tabs
                if (activeTab !== 'ai-den') {
                    actions = [
                        {
                            id: 'runThrough',
                            text: "\u25BA " + this.translate.instant('run.scheduled.activities'),
                            onClick: function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return runThrough.apply(void 0, args);
                            },
                            actionTypeProps: { bgColour: '#746CA6' },
                            hide: function () { return !_this.RunThroughScheduledActivitiesAccess; },
                            disable: function () { return !_this.filterActionEnabled || _this.isOldJobView; }
                        },
                    ];
                }
                break;
            case 'othersActivity':
            case 'complete':
                filters = [
                    {
                        filterInterfaceLabel: 'Activity type',
                        ID: 'activityType',
                        filterType: 'staticMultiSelect',
                        filterOptions: [
                            { id: '1', text: 'Call' },
                            { id: '2', text: 'Email' },
                            { id: '3', text: 'Meeting' },
                            { id: '4', text: 'Task' },
                        ],
                    },
                    {
                        filterInterfaceLabel: 'Record type',
                        ID: 'recordType',
                        filterType: 'staticSingleSelect',
                        filterOptions: [
                            { id: 'all', text: "All" },
                            { id: 'customer', text: "Customer" },
                            { id: 'opportunity', text: "Opportunity" },
                            { id: 'contract', text: 'Contract' },
                            { id: 'job', text: 'Job' }
                        ],
                    },
                    {
                        filterInterfaceLabel: 'Due dates',
                        ID: 'dueDate',
                        filterType: 'staticSingleSelect',
                        filterOptions: [
                            { id: 'All dates', text: "All dates" },
                            { id: 'Today', text: "Due today" },
                            { id: 'Overdue', text: "Overdue" },
                            { id: 'Tomorrow', text: "Due tomorrow" },
                            { id: 'Week', text: "Due this week" },
                            { id: 'Next_week', text: "Due next week" },
                        ],
                    },
                    {
                        filterInterfaceLabel: 'Displayed by',
                        ID: 'assignee',
                        filterType: 'staticSingleSelect',
                        filterOptions: activeTab == 'othersActivity' ? this.usersList.filter(function (u) { return u.id != _this.currentUser.id; }) : this.usersList,
                    },
                ];
                // No actions for 'complete'
                if (activeTab !== 'complete') {
                    actions = [
                        {
                            id: 'runThrough',
                            text: "\u25BA " + this.translate.instant('run.scheduled.activities'),
                            onClick: function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return runThrough.apply(void 0, args);
                            },
                            actionTypeProps: { bgColour: '#746CA6' },
                            hide: function () { return !_this.RunThroughScheduledActivitiesAccess; },
                            disable: function () { return !_this.filterActionEnabled || _this.isOldJobView; }
                        },
                    ];
                }
                break;
            default:
                filters = [];
                actions = [];
                appliedFilter = [];
                break;
        }
        return { filters: filters, actions: actions, appliedFilter: appliedFilter };
    };
    ScheduledActivityService.prototype.ModifyActivityDate = function (date) {
        var mDate = moment(date);
        var today = moment().startOf('day');
        var tomorrow = today.clone().add(1, 'day');
        var tooltipDate = mDate.format('DD/MM/YYYY (HH:mm)');
        var label = '';
        // Past dates
        if (mDate.isBefore(today, 'day')) {
            label = 'Overdue';
        }
        // Today
        else if (mDate.isSame(today, 'day')) {
            label = 'Due today';
        }
        // Tomorrow
        else if (mDate.isSame(tomorrow, 'day')) {
            label = 'Due tomorrow';
        }
        else {
            // After tomorrow
            var diffDays = mDate.diff(today, 'days');
            var diffWeeks = mDate.diff(today, 'weeks');
            var diffMonths = mDate.diff(today, 'months');
            if (diffDays < 7) {
                label = diffDays + " day" + (diffDays > 1 ? 's' : '') + " left";
            }
            else if (diffWeeks < 5) {
                label = diffWeeks + " week" + (diffWeeks > 1 ? 's' : '') + " left";
            }
            else {
                label = diffMonths + " month" + (diffMonths > 1 ? 's' : '') + " left";
            }
        }
        return {
            label: label,
            tooltip: tooltipDate
        };
    };
    ScheduledActivityService.prototype.ModifyActivityDateTime = function (date) {
        var value = moment(date).calendar(null, {
            lastDay: '[Yesterday]',
            sameDay: '[Today]',
            nextDay: '[Tomorrow]'
        });
        if (value == 'Today' || value == 'Tomorrow' || value == 'Yesterday') {
            var convertedDate = this.ShortDatePipe.transform(date);
            date = moment.utc(date);
            var currentTime = this.TimelineDatePipe.transform(date, 'datetime');
            var currentHourTime = currentTime.match(/\(([^)]+)\)/);
            return value + " on " + convertedDate + " at " + currentHourTime[1];
        }
        else {
            var convertedDate = this.ShortDatePipe.transform(date);
            date = moment.utc(date);
            var currentTime = this.TimelineDatePipe.transform(date, 'datetime');
            var currentHourTime = currentTime.match(/\(([^)]+)\)/);
            return "Due on " + convertedDate + " at " + currentHourTime[1];
        }
    };
    ScheduledActivityService.prototype.getScheduledActivitiesCount = function (activeTab) {
        var url = this.getApiUrl("getScheduledActivitiesCount?activeTab=" + activeTab);
        return this.http.get(url);
    };
    ScheduledActivityService.LAST_COMM_DEBOUNCE_MS = 1000;
    return ScheduledActivityService;
}(InterfaceService));
export { ScheduledActivityService };
